// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =======================================================
   proceduresModal.css – estilos para ProceduresModal
   ======================================================= */

/* ----- overlay & container (herda se já existir) ------- */
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  background: rgba(0, 0, 0, 0.55);
  z-index: 1050;
}

.procedures-modal {
  width: 100%;
  max-width: 780px;
  max-height: 92vh;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  animation: pop 0.25s ease-out;
}
@keyframes pop {
  from {
    transform: translateY(16px) scale(0.96);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

/* ----- header ----------------------------------------- */
.modal-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.modal-header h2 {
  flex: 1 1;
  margin: 0;
  font-size: 1.35rem;
  font-weight: 600;
  color: #111827;
}
.close-button {
  background: transparent;
  border: 0;
  color: #6b7280;
  line-height: 0;
  border-radius: 6px;
  padding: 0.25rem;
  transition: background 0.15s, color 0.15s;
}
.close-button:hover,
.close-button:focus-visible {
  background: #f3f4f6;
  color: #111827;
  outline: none;
}

/* ----- busca e filtros -------------------------------- */
.modal-search {
  
}

/* busca */
.search-input {
  position: relative;
  border: none;
}
.search-input svg {
  position: absolute;
  top: 50%;
  left: 0.75rem;
  transform: translateY(-50%);
  color: #9ca3af;
}
.search-input input {
  width: 100%;
  padding: 0.55rem 0.75rem 0.55rem 2.4rem;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.search-input input:focus-visible {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);
  outline: none;
}

/* select setor */
.sector-filter label {
  display: block;
  font-size: 0.8rem;
  color: #374151;
  margin-bottom: 0.15rem;
}
.sector-filter select {
  padding: 0.45rem 0.8rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.9rem;
  background: #fff;
}
.sector-filter select:focus-visible {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);
  outline: none;
}

/* selecionar todos */
.select-all-label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  -webkit-user-select: none;
          user-select: none;
  margin: 0 !important;
}

.select-all-label input {
  accent-color: #2563eb;
}

/* ----- barra de ação em lote -------------------------- */
.bulk-payment-bar {
  padding: 0.75rem 1.5rem;
  border-top: 1px dashed #d1d5db;
  border-bottom: 1px dashed #d1d5db;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.85rem;
  flex-wrap: wrap;
}
.bulk-payment-bar button,
.bulk-payment-bar select {
  font-size: 0.85rem;
  padding: 0.45rem 0.9rem;
  border-radius: 6px;
  border: 1px solid #2563eb;
  background: #2563eb;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s, box-shadow 0.15s;
}
.bulk-payment-bar button:hover,
.bulk-payment-bar select:hover {
  background: #1d4ed8;
}
.bulk-payment-bar select {
  background: #fff;
  color: #111827;
  border-color: #d1d5db;
}
.bulk-payment-bar select:focus-visible {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);
  outline: none;
}

/* ----- mensagem de erro ------------------------------- */
.error-message {
  margin: 0.75rem 1.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  color: #b91c1c;
}

/* ----- lista de procedimentos ------------------------- */
.procedures-list {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: .5rem;
}
.procedure-item {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  display: flex;
  gap: 0.9rem;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.procedure-item:hover {
  border-color: #2563eb;
}
.procedure-item.selected {
  background: #eef4ff;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25);
}

.procedure-checkbox input {
  accent-color: #d97706; /* laranja para diferenciar */
  margin-top: 4px;
}

.procedure-details h4 {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}
.procedure-details small {
  font-size: 0.75rem;
  color: #6b7280;
}

/* ----- payment-choice em cada card -------------------- */
.payment-choice {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
}
.payment-choice label {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.8rem;
  -webkit-user-select: none;
          user-select: none;
}
.payment-choice input[type="radio"] {
  accent-color: #2563eb;
}
.payment-choice select {
  padding: 0.25rem 0.6rem;
  font-size: 0.8rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
}
.payment-choice select:focus-visible {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);
  outline: none;
}

/* ----- footer ----------------------------------------- */
.modal-footer {
  border-top: 1px solid #e5e7eb;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.available-doctors {
  font-size: 0.85rem;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
.cancel-button,
.schedule-button {
  padding: 0.5rem 1.25rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  border: 0;
  cursor: pointer;
  transition: background 0.15s, box-shadow 0.15s;
}
.cancel-button {
  background: #f3f4f6;
  color: #374151;
}
.cancel-button:hover {
  background: #e5e7eb;
}
.schedule-button {
  background: #2563eb;
  color: #fff;
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.4);
}
.schedule-button:hover:enabled {
  background: #1d4ed8;
}
.schedule-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/views/newPosConsult/css/proceduresModal.css"],"names":[],"mappings":"AAAA;;4DAE4D;;AAE5D,4DAA4D;AAC5D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;EAC3C,6BAA6B;AAC/B;AACA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAO;EACP,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA,2DAA2D;AAC3D;;AAEA;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,8CAA8C;AAChD;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB,EAAE,6BAA6B;EACpD,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["/* =======================================================\n   proceduresModal.css – estilos para ProceduresModal\n   ======================================================= */\n\n/* ----- overlay & container (herda se já existir) ------- */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(2px);\n  background: rgba(0, 0, 0, 0.55);\n  z-index: 1050;\n}\n\n.procedures-modal {\n  width: 100%;\n  max-width: 780px;\n  max-height: 92vh;\n  background: #fff;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  animation: pop 0.25s ease-out;\n}\n@keyframes pop {\n  from {\n    transform: translateY(16px) scale(0.96);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n/* ----- header ----------------------------------------- */\n.modal-header {\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.modal-header h2 {\n  flex: 1;\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: #111827;\n}\n.close-button {\n  background: transparent;\n  border: 0;\n  color: #6b7280;\n  line-height: 0;\n  border-radius: 6px;\n  padding: 0.25rem;\n  transition: background 0.15s, color 0.15s;\n}\n.close-button:hover,\n.close-button:focus-visible {\n  background: #f3f4f6;\n  color: #111827;\n  outline: none;\n}\n\n/* ----- busca e filtros -------------------------------- */\n.modal-search {\n  \n}\n\n/* busca */\n.search-input {\n  position: relative;\n  border: none;\n}\n.search-input svg {\n  position: absolute;\n  top: 50%;\n  left: 0.75rem;\n  transform: translateY(-50%);\n  color: #9ca3af;\n}\n.search-input input {\n  width: 100%;\n  padding: 0.55rem 0.75rem 0.55rem 2.4rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.search-input input:focus-visible {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);\n  outline: none;\n}\n\n/* select setor */\n.sector-filter label {\n  display: block;\n  font-size: 0.8rem;\n  color: #374151;\n  margin-bottom: 0.15rem;\n}\n.sector-filter select {\n  padding: 0.45rem 0.8rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  background: #fff;\n}\n.sector-filter select:focus-visible {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);\n  outline: none;\n}\n\n/* selecionar todos */\n.select-all-label {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.85rem;\n  user-select: none;\n  margin: 0 !important;\n}\n\n.select-all-label input {\n  accent-color: #2563eb;\n}\n\n/* ----- barra de ação em lote -------------------------- */\n.bulk-payment-bar {\n  padding: 0.75rem 1.5rem;\n  border-top: 1px dashed #d1d5db;\n  border-bottom: 1px dashed #d1d5db;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.85rem;\n  flex-wrap: wrap;\n}\n.bulk-payment-bar button,\n.bulk-payment-bar select {\n  font-size: 0.85rem;\n  padding: 0.45rem 0.9rem;\n  border-radius: 6px;\n  border: 1px solid #2563eb;\n  background: #2563eb;\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.15s, box-shadow 0.15s;\n}\n.bulk-payment-bar button:hover,\n.bulk-payment-bar select:hover {\n  background: #1d4ed8;\n}\n.bulk-payment-bar select {\n  background: #fff;\n  color: #111827;\n  border-color: #d1d5db;\n}\n.bulk-payment-bar select:focus-visible {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);\n  outline: none;\n}\n\n/* ----- mensagem de erro ------------------------------- */\n.error-message {\n  margin: 0.75rem 1.5rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.85rem;\n  color: #b91c1c;\n}\n\n/* ----- lista de procedimentos ------------------------- */\n.procedures-list {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 1rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: .5rem;\n}\n.procedure-item {\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 1rem 1.25rem;\n  display: flex;\n  gap: 0.9rem;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n.procedure-item:hover {\n  border-color: #2563eb;\n}\n.procedure-item.selected {\n  background: #eef4ff;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25);\n}\n\n.procedure-checkbox input {\n  accent-color: #d97706; /* laranja para diferenciar */\n  margin-top: 4px;\n}\n\n.procedure-details h4 {\n  margin: 0 0 2px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n.procedure-details small {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n/* ----- payment-choice em cada card -------------------- */\n.payment-choice {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 0.5rem;\n  flex-wrap: wrap;\n}\n.payment-choice label {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.8rem;\n  user-select: none;\n}\n.payment-choice input[type=\"radio\"] {\n  accent-color: #2563eb;\n}\n.payment-choice select {\n  padding: 0.25rem 0.6rem;\n  font-size: 0.8rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n}\n.payment-choice select:focus-visible {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);\n  outline: none;\n}\n\n/* ----- footer ----------------------------------------- */\n.modal-footer {\n  border-top: 1px solid #e5e7eb;\n  padding: 1rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.available-doctors {\n  font-size: 0.85rem;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n.cancel-button,\n.schedule-button {\n  padding: 0.5rem 1.25rem;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  border: 0;\n  cursor: pointer;\n  transition: background 0.15s, box-shadow 0.15s;\n}\n.cancel-button {\n  background: #f3f4f6;\n  color: #374151;\n}\n.cancel-button:hover {\n  background: #e5e7eb;\n}\n.schedule-button {\n  background: #2563eb;\n  color: #fff;\n  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.4);\n}\n.schedule-button:hover:enabled {\n  background: #1d4ed8;\n}\n.schedule-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
